export const globalStyles = `
  *{
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  
  html,
  body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type=number] {
    -moz-appearance: textfield;
  }
  
  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    border-radius: 6px;
  }
`;
